module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["accordion-wrapper"]
  }, [_c('div', {
    staticClass: ["accordion-item"],
    on: {
      "click": _vm.makeSwitch
    }
  }, [_c('text', {
    staticClass: ["accordion-title"]
  }, [_vm._v(_vm._s(_vm.title))]), _c('image', {
    staticClass: ["accordion-icon"],
    attrs: {
      "src": _vm.isFolded ? _vm.foldIcon : _vm.unfoldIcon
    }
  })]), (!_vm.isFolded) ? _c('div', [_vm._t("content")], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-756307a5!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-accordion/index.vue
// module id = 644
// module chunks = 0 1